import React, { useState, useEffect, useRef } from 'react';
import { useLocation } from 'cccisd-react-router';
import { CV_URL } from '../../pages/Welcome';
import ShareLogo from '../../components/Header/SHARE-Logo.svg';
import LearnLogo from '../../components/Header/Learn_Logo.svg';
import AssistLogo from '../../../images/assistmh-logo.png';
import WalletIcon from './wallet.svg';
import DesktopNav from './DesktopNav';
import MobileNav from './MobileNav';
import style from './style.css';

const Boilerplate = window.cccisd.boilerplate;
const MOBILE_MAX = parseInt(style.mobileMax, 10);

let links = [
    {
        to: CV_URL + '/educator',
        icon: 'home',
        label: 'Home',
    },
    {
        to: CV_URL + '/educator/purchasing',
        icon: 'purchasing',
        label: 'Purchasing',
    },
    {
        to: 'https://www.centervention.com/support/',
        icon: 'support',
        label: 'Support',
    },
    {
        to: '#',
        icon: 'settings',
        label: 'Account Settings',
        children: [
            {
                to: CV_URL + '/educator#profile',
                icon: 'profile',
                label: 'Profile',
            },
            {
                to: CV_URL + '/educator#classcode',
                icon: 'lock',
                label: 'Class Code',
            },
            {
                to: CV_URL + '/educator#password',
                icon: 'key',
                label: 'Password',
            },
            {
                to: Boilerplate.url('/api/user/logout'), // will logout of both 3C and Centervention
                icon: 'logout',
                label: 'Logout',
            },
        ],
    },
];

const assessmentTabLinks = [
    {
        to: '/students',
        icon: 'students',
        label: 'Students',
    },
    {
        to: '/administer',
        icon: 'administer',
        label: 'Administer',
    },
    {
        to: '/results',
        icon: 'results',
        label: 'Results',
    },
    {
        to: '/assessment-library',
        icon: 'assessmentLibrary',
        label: 'Assessment Library',
    },
    {
        to: '/help',
        icon: 'question',
        label: 'SHARE Help',
    },
];

const Fortress = window.cccisd.fortress;

const CvSideNavLayout = props => {
    const headerRef = useRef(null);
    const location = useLocation();
    const [isMobile, setIsMobile] = useState(window.innerWidth <= MOBILE_MAX);
    const [displayName, setDisplayName] = useState('');
    const [headerHeight, setHeaderHeight] = useState(0);
    const acting = Fortress.user.acting || {};

    function checkHeaderHeight() {
        let currHeaderHeight = headerRef?.current ? headerRef.current.getBoundingClientRect().height : 0;
        if (window.innerWidth <= MOBILE_MAX && acting.role.handle === 'instructor') {
            currHeaderHeight += 52;
        }
        setHeaderHeight(currHeaderHeight);
    }

    function checkIsMobile() {
        if (!isMobile && window.innerWidth <= MOBILE_MAX) {
            setIsMobile(true);
        } else if (isMobile && window.innerWidth > MOBILE_MAX) {
            setIsMobile(false);
        }

        checkHeaderHeight();
    }
    useEffect(() => {
        checkHeaderHeight();
        window.addEventListener('resize', checkIsMobile);
        return () => window.removeEventListener('resize', checkIsMobile);
    }, [isMobile, headerRef?.current]);

    useEffect(() => {
        const user = acting.user || {};
        let name = user.full_name;
        if (!name && user.last_name && user.first_name) {
            name = `${user.first_name} ${user.last_name}`;
        } else if (!name && user.first_name) {
            name = user.first_name;
        } else if (!name) {
            name = user.username;
        }

        setDisplayName(name);
    }, []);

    let logo = ShareLogo;
    let extraLinks = assessmentTabLinks;
    if (location.pathname.includes('pd-center')) {
        logo = LearnLogo;
        extraLinks = [];
    } else if (location.pathname.includes('assist')) {
        logo = AssistLogo;
        extraLinks = [];
    } else if (location.pathname.includes('cvlogin')) {
        logo = null;
        extraLinks = [];
    }

    const linksToUse = links.toSpliced(3, 0, ...extraLinks);

    const isFreeTrial = acting.role_data?.isCvFreeTrial;
    const freeTrialDaysRemaining = acting.role_data?.cvFreeTrialDaysRemaining;

    const isShowNavigation = Fortress.auth() && acting.role.handle === 'instructor';

    return (
        <div className={`${style.page} ${isMobile ? '' : 'd-flex'}`} data-centervention-side-nav={acting.id}>
            {isShowNavigation && (isMobile ? <MobileNav links={linksToUse} /> : <DesktopNav links={linksToUse} />)}
            <div className={style.body}>
                <div className={`${style.header} ${isMobile ? style.isMobile : ''}`} ref={headerRef}>
                    <div className={style.logo}>{logo && <img src={logo} alt="SHARE site logo" />}</div>
                    {!isMobile && <div className={style.name}>{displayName}</div>}
                    <div className={style.freeTrialStatus}>
                        {!!isFreeTrial && (
                            <>
                                <img src={WalletIcon} alt="wallet" className={style.walletIcon} />
                                <p className={style.trialExpiration}>
                                    Free Trial Expires in <b>{freeTrialDaysRemaining}</b> days
                                </p>
                            </>
                        )}
                    </div>
                </div>
                <div
                    className={`${style.content} ${
                        location.pathname.includes('sessionPlayer') ? style.sessionPlayer : ''
                    }`}
                >
                    {React.cloneElement(props.children, { setDisplayName, headerHeight })}
                </div>
            </div>
        </div>
    );
};

export default CvSideNavLayout;
